import React from 'react';

export default function SheepHornsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="38.0,23.6 32.46,23.6 32.46,15.29 38.0,15.29" fill="#DFD2DF" />
      <polygon points="32.46,23.6 38.0,23.6 34.68,21.94 29.14,21.94" fill="#B496B4" opacity="0.95" />
      <polygon points="32.46,23.6 29.14,21.94 29.14,13.63 32.46,15.29" fill="#B496B4" opacity="0.95" />
      <polygon points="11.69,23.6 6.15,23.6 6.15,15.29 11.69,15.29" fill="#DFD2DF" />
      <polygon points="6.15,23.6 11.69,23.6 8.37,21.94 2.83,21.94" fill="#B496B4" opacity="0.95" />
      <polygon points="6.15,23.6 2.83,21.94 2.83,13.63 6.15,15.29" fill="#B496B4" opacity="0.95" />
      <polygon points="38.0,26.37 32.46,26.37 32.46,23.6 38.0,23.6" fill="#DFD2DF" />
      <polygon points="32.46,26.37 38.0,26.37 33.85,24.29 28.31,24.29" fill="#B496B4" opacity="0.95" />
      <polygon points="32.46,26.37 28.31,24.29 28.31,21.52 32.46,23.6" fill="#B496B4" opacity="0.95" />
      <polygon points="11.69,26.37 6.15,26.37 6.15,23.6 11.69,23.6" fill="#DFD2DF" />
      <polygon points="6.15,26.37 11.69,26.37 7.54,24.29 2.0,24.29" fill="#B496B4" opacity="0.95" />
      <polygon points="6.15,26.37 2.0,24.29 2.0,21.52 6.15,23.6" fill="#B496B4" opacity="0.95" />
    </svg>
  );
}
